const numberFormats = {
    "zh-TW": {
        decimal: {
            style: "decimal",
            maximumFractionDigits: 2,
        },
    },
};

export default numberFormats;
